import Marquee from "react-fast-marquee";

const WORDS = ["Governance", "Strategy", "Training", "Community"];

const EditorialMarquee = ({ dark = false }) => (
  <div
    className={`overflow-hidden border-y py-8 sm:py-10 select-none ${
      dark ? "bg-pine border-moss" : "bg-cream border-line"
    }`}
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <Marquee speed={28} gradient={false} pauseOnHover={false}>
      {Array.from({ length: 3 }).flatMap((_, r) =>
        WORDS.map((w, i) => (
          <span key={`${r}-${w}`} className="flex items-center">
            <span
              className={`font-serif text-5xl sm:text-7xl font-medium px-6 sm:px-10 ${
                (i + r) % 2 === 0
                  ? dark
                    ? "text-outline-cream"
                    : "text-outline-pine"
                  : "text-gold italic"
              }`}
            >
              {w}
            </span>
            <span className={`h-2 w-2 rotate-45 ${dark ? "bg-gold/70" : "bg-gold"}`} />
          </span>
        ))
      )}
    </Marquee>
  </div>
);

export default EditorialMarquee;
